<template>
  <div
    class="header-top-bar"
    :style="{
      backgroundColor: bgColor
    }"
  >
    <div
      class="inner-bar"
      :style="{
        width: `${width}px`,
      }"
    >
      <template v-if="!login">
        <div
          class="text-button"
          :style="{
            color: loginTextColor
          }"
          @click="onLoginClick('login')"
        >
          {{ loginText }}
        </div>
        <div class="divider">|</div>
        <div
          class="text-button"
          :style="{
            color: registerTextColor
          }"
          @click="onLoginClick('register')"
        >
          {{ registerText }}
        </div>
      </template>
      <template v-else>
        <div
          class="text-button"
          :style="{
            color: loginTextColor
          }"
          @click="goOrderList"
        >
          {{ userInfo.loginName }}
        </div>
        <div class="divider">|</div>
        <div
          class="text-button"
          :style="{
            color: registerTextColor
          }"
          @click="logout"
        >
          退出
        </div>
      </template>
    </div>
    <Modal v-model="showLoginModel" :width="460">
      <div class="header-login-wrapper">
        <Login class="login-module" :loginBtn="loginBtn"></Login>
      </div>
      <div slot="footer"></div>
    </Modal>
  </div>
</template>

<script>
import { apiGet } from "@/fetch/api";
import { mapState, mapMutations } from "vuex";

import Login from "@/components/login";
export default {
  props: {
    bgColor: {
      type: String,
      default: "#F9F9F9"
    },
    width: {
      type: Number,
      default: 1200
    },
    loginText: {
      type: String,
      default: "登录"
    },
    loginTextColor: {
      type: String,
      default: "#999"
    },
    registerText: {
      type: String,
      default: "注册"
    },
    registerTextColor: {
      type: String,
      default: "#2B77DF"
    }
  },
  components: {
    Login
  },
  data() {
    return {
      showLoginModel: false,
      loginBtn:false,
    };
  },
  computed: {
    ...mapState(["login", "userInfo", "loginShow"])
  },
  methods: {
    ...mapMutations(['removeTokenInfo']),
    onLoginClick(type) {
      this.showLoginModel = true;
      if(type==='register'){
        this.loginBtn=true
      }
      if(type==='login'){
        this.loginBtn=false
      }
    },
    goOrderList() {
      this.$router.push({ path: "/order/list", query: this.$route.query });
    },
    // 搬运header里的方法
    logout() {
      let _this = this;
      apiGet("/leaguer/api/userLeaguer/manage/leaguerLogout", {
        merchantInfoId: this.$route.query.m_id || localStorage.getItem("m_id")
      }).then(res => {
        if (res.status == 200) {
          // localStorage.clear();
          // localStorage.removeItem("xjsc_login_access_token_2019_3_7");
          this.removeTokenInfo()
          localStorage.removeItem("xjsc_login_userId_2019_3_8");
          // _this.reload();
          location.reload();
          // _this.refresh();
          _this.$Message.success("退出成功!");
          _this.$store.dispatch("updateLogin", false);
        } else {
          _this.$Message.warning(res.message);
        }
      });
      // _this.refresh();
    }
  },
  watch: {
    loginShow(val) {
      this.showLoginModel = val;
    },
    showLoginModel(val) {
      this.$store.dispatch("updateLoginShow", val);
    }
  }
};
</script>

<style scoped lang="scss">
.header-top-bar {
  text-align: center;
  width: 100%;
  height: 30px;
  .inner-bar {
    height: 100%;
    display: inline-flex;
    justify-content: center;
    background-color: #4e8f8b;
    .text-button {
      cursor: pointer;
    }
    
  }
}
</style>
<style lang="scss">
.header-login-wrapper {
  width: 100%;
  position: relative;
  .login-block {
    position: relative !important;
  }
  .login-module {
    position: relative;
    top: 0 !important;
    left: 0 !important;
    margin: auto !important;
  }
}
.divider {
  padding: 0 10px;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/pages/keqi/components/headerBar.vue